import { type Patient } from '@/types/patient'
import { formatPhoneNumber } from '@quickmd-llc/frontend-utils'
import {
  CalendarIcon,
  EnvelopeIcon,
  Paragraph,
  PassportIcon,
  PhoneIcon,
  StethoscopeIcon,
} from '@quickmd-llc/design-system'
import moment from 'moment-timezone'

type Props = {
  patient: Patient
}

export function AccountCardDetails({ patient }: Props) {
  const { BirthDate, Email, LastSeenDateTime, MedicalRecordNumber, PhoneNumber } = patient

  const patientDob = moment(BirthDate).format('MM/DD/YYYY')
  const patientPhone = formatPhoneNumber(PhoneNumber.Number)
  const recentVisitDate = LastSeenDateTime && moment(LastSeenDateTime).format('MM/DD/YYYY')

  return (
    <div className='flex flex-wrap gap-sp-1'>
      <div className='flex items-center gap-sp-0.5'>
        <EnvelopeIcon className='text-text-medium' />

        <Paragraph>{Email}</Paragraph>
      </div>

      <div className='flex items-center gap-sp-0.5'>
        <CalendarIcon className='text-text-medium' />

        <Paragraph>- DOB {patientDob}</Paragraph>
      </div>

      <div className='flex items-center gap-sp-0.5'>
        <PhoneIcon className='text-text-medium' />

        <Paragraph>{patientPhone}</Paragraph>
      </div>

      <div className='flex items-center gap-sp-0.5'>
        <PassportIcon className='text-text-medium' />

        <Paragraph>MRN - {MedicalRecordNumber}</Paragraph>
      </div>

      {recentVisitDate ?
        <div className='flex items-center gap-sp-0.5'>
          <StethoscopeIcon className='text-text-medium' />

          <Paragraph>Recent visit - {recentVisitDate}</Paragraph>
        </div>
      : null}
    </div>
  )
}
